import { render, staticRenderFns } from "./TemplateProject.vue?vue&type=template&id=0fd92031"
import script from "./TemplateProject.vue?vue&type=script&lang=js"
export * from "./TemplateProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports